import { Blocs } from '@business/blocs';
import * as React from 'react';
import { AppConfig } from '@core/utils/config';
import { CompanyId, CompanyResponse } from '@business/entities/companies';
import { useSubscribe } from '../rxjs';
import { R } from '@core/utils/r';
import { Session } from '@modules/auth/session';

export function useCompany() {
  const currentValue = AppConfig.changed$.value;

  const getCompany = React.useCallback((companyId: CompanyId | null) => {
    const nCompany = {
      id: '1',
      name: '',
      logo: '',
      currencyCode: '',
    } as CompanyResponse;

    if (Session.user) {
      return R.find(Session.user.companies, company => company.id === companyId) || nCompany;
    }

    return nCompany;
  }, []);

  const [company, setCompany] = React.useState<CompanyResponse>(getCompany(currentValue.companyId));

  useSubscribe(AppConfig.changed$, conf => {
    setCompany(getCompany(conf.companyId));
  });

  return company;
}

export function getCurrentCompany() {
  const currentValue = AppConfig.changed$.value;

  const nCompany = {
    id: '1',
    name: '',
    logo: '',
    currencyCode: '',
  } as CompanyResponse;

  if (Session.user) {
    return R.find(Session.user.companies, company => company.id === currentValue.companyId) || nCompany;
  }

  return nCompany;
}

export function useCurrencies() {
  const company = useCompany();
  const otherCurrencies = company.activeCurrencies.map(item => item.name);
  return {
    default: company.currencyCode,
    otherCurrencies,
    allCurrencies: [company.currencyCode, ...otherCurrencies],
  };
}
